import './fixAriaHidden';
//  import { setGlobalToastConfig } from './hooks/useGlobalToast';
//  import './vanillaToastInterceptor'; 
import { Suspense, lazy } from "react";
// import './stopOldToastGlobally';
// import './testToast';  
import "chart.js/auto";
import { Toast } from 'react-bootstrap';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import ClaimDetails from '../src/pages/Payroll/components/Reimbursement/ClaimDetails';
// import Reimbursement from '../src/pages/Payroll/components/Reimbursement/Reimbursement';

import PolicyLimits from "../src/pages/Payroll/components/Reimbursement/policylimit";

// At the top of App.js, add the import
import GeneratePayslip from './setting/settingBody/GeneratePayslip/GeneratePayslip';



import { GlobalToastProvider } from './stopOldToastGlobally';
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import { ThemeProvider } from "./themeContext";
import "./App.css";

import routes from "./routes";
import useGlobalSelectStyling from "./utils/SelectOption";
import { SnackBar as AppSnackBar } from "./components/shared";

// Import Toast Provider


// Lazy load routes with improved loading
const PublicRoutes = lazy(() =>
  import("./routes/publicRoutes").then(module => ({
    default: module.default
  }))
);

const PrivateRoutes = lazy(() =>
  import("./routes/privateRoutes").then(module => ({
    default: module.default
  }))
);

// Improved Loader Component
const AppLoader = () => (
  <div className="app-loader">
    <div className="loader-spinner">
      <div className="spinner"></div>
    </div>
    <div className="loader-text">Loading application...</div>
  </div>
);

// Route Loader Component for individual routes
const RouteLoader = () => (
  <div className="route-loader">
    <div className="loader-spinner">
      <div className="spinner"></div>
    </div>
  </div>
);

// Create a wrapper component
const AppContent = ({ children }) => {
  return children;
};

// Preload critical components for better UX
const preloadComponents = () => {
  // Preload auth-related components
  import("./routes/publicRoutes");
  import("./routes/privateRoutes");
};

function App() {
  useGlobalSelectStyling();
  const { isLoggedIn, superAdmin } = useSelector((state) => state.auth);

  // Preload components on app initialization
  preloadComponents();

  const routeConfig = routes();

  return (
    <ThemeProvider>
      {/* ✅ SINGLE ToastProvider wrapping everything */}
      <GlobalToastProvider>
        <AppContent>
          <Suspense fallback={<AppLoader />}>
            <Routes>
              {/* ---------- PUBLIC ROUTES ---------- */}
              <Route
                element={
                  <Suspense fallback={<RouteLoader />}>
                    <PublicRoutes
                      isLoggedIn={isLoggedIn}
                      superAdmin={superAdmin}
                    />
                  </Suspense>
                }
              >
                {routeConfig.publicRoutes.map(
                  ({ path, Component, children }, index) => (
                    <Route key={index} path={path} element={
                      <Suspense fallback={<RouteLoader />}>
                        {Component}
                      </Suspense>
                    }>
                      {children?.map(({ path, element }, i) => (
                        <Route
                          key={i}
                          path={path}
                          element={
                            <Suspense fallback={<RouteLoader />}>
                              {element}
                            </Suspense>
                          }
                        />
                      ))}
                    </Route>
                  )
                )}
              </Route>
      <Route path="/policy-limits" element={<PolicyLimits />} />
      <Route path="/claim-details" element={<ClaimDetails />} />

              <Route path="/generate-payslip" element={<GeneratePayslip />} />
              {/* ---------- ONBOARDING ROUTES ---------- */}
              <Route>
                {routeConfig.onboardingRoute.map(
                  ({ path, Component, children }, index) => (
                    <Route key={index} path={path} element={
                      <Suspense fallback={<RouteLoader />}>
                        {Component}
                      </Suspense>
                    }>
                      {children?.map(({ path, element }, i) => (
                        <Route
                          key={i}
                          path={path}
                          element={
                            <Suspense fallback={<RouteLoader />}>
                              {element}
                            </Suspense>
                          }
                        />
                      ))}
                    </Route>
                  )
                )}
              </Route>

              {/* ---------- PRIVATE ROUTES ---------- */}
              <Route
                element={
                  <Suspense fallback={<RouteLoader />}>
                    <PrivateRoutes
                      isLoggedIn={isLoggedIn}
                      superAdmin={superAdmin}
                    />
                  </Suspense>
                }
              >
                {routeConfig.privateRoutes.map(
                  ({ path, Component, children }, index) => (
                    <Route key={index} path={path} element={
                      <Suspense fallback={<RouteLoader />}>
                        {Component}
                      </Suspense>
                    }>
                      {children?.map(({ path, Component, children }, i) => (
                        <Route key={i} path={path} element={
                          <Suspense fallback={<RouteLoader />}>
                            {Component}
                          </Suspense>
                        }>
                          {children?.map(({ path, Component }, j) => (
                            <Route
                              key={j}
                              path={path}
                              element={
                                <Suspense fallback={<RouteLoader />}>
                                  {Component}
                                </Suspense>
                              }
                            />
                          ))}
                        </Route>
                      ))}
                    </Route>
                  )
                )}
              </Route>
            </Routes>
            <AppSnackBar />

          </Suspense>
        </AppContent>
      </GlobalToastProvider>
    </ThemeProvider>
  );
}

export default App;